import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3402';

export interface LegalHold {
  id: string;
  userId: string;
  reason: string;
  caseNumber?: string;
  externalReference?: string;
  holdType: 'FULL' | 'PAYOUT_ONLY' | 'CONTENT_ONLY';
  startDate: Date;
  endDate?: Date;
  status: 'ACTIVE' | 'RELEASED';
  createdBy: string;
  releaseReason?: string;
  releasedBy?: string;
  releasedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  user?: {
    id: string;
    username: string;
    displayName: string;
    email: string;
  };
}

export interface CreateLegalHoldData {
  userId: string;
  reason: string;
  caseNumber?: string;
  externalReference?: string;
  holdType: 'FULL' | 'PAYOUT_ONLY' | 'CONTENT_ONLY';
  endDate?: string;
}

export interface ReleaseLegalHoldData {
  releaseReason: string;
}

const legalHoldService = {
  // Create legal hold
  create: async (data: CreateLegalHoldData): Promise<LegalHold> => {
    const response = await axios.post(`${API_URL}/api/admin/legal-holds`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get all legal holds
  getAll: async (params?: {
    status?: string;
    userId?: string;
  }): Promise<LegalHold[]> => {
    const response = await axios.get(`${API_URL}/api/admin/legal-holds`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get single legal hold
  getById: async (id: string): Promise<LegalHold> => {
    const response = await axios.get(`${API_URL}/api/admin/legal-holds/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get user's legal holds
  getUserHolds: async (userId: string): Promise<LegalHold[]> => {
    const response = await axios.get(`${API_URL}/api/admin/legal-holds/user/${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Release legal hold
  release: async (id: string, data: ReleaseLegalHoldData): Promise<LegalHold> => {
    const response = await axios.post(
      `${API_URL}/api/admin/legal-holds/${id}/release`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data;
  },

  // Update legal hold
  update: async (id: string, data: Partial<CreateLegalHoldData>): Promise<LegalHold> => {
    const response = await axios.patch(`${API_URL}/api/admin/legal-holds/${id}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Delete legal hold
  delete: async (id: string): Promise<void> => {
    await axios.delete(`${API_URL}/api/admin/legal-holds/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  },
};

export default legalHoldService;
